module.exports = __webpack_public_path__ + "img/1F602.88291388.svg";